/**
 * Tuition post service — CRUD, browse, filtering.
 */
import apiClient from './apiClient';

/**
 * Get tuition posts with optional filters.
 */
export const getTuitionPosts = async (filters = {}) => {
    const params = new URLSearchParams(filters);
    return apiClient.get(`/tuition-posts?${params.toString()}`);
};

/**
 * Get single tuition post by ID.
 */
export const getTuitionPostById = async (id) => {
    return apiClient.get(`/tuition-posts/${id}`);
};

/**
 * Get my tuition posts (requires auth).
 */
export const getMyTuitionPosts = async () => {
    return apiClient.get('/tuition-posts/my');
};

/**
 * Create a new tuition post (requires auth).
 */
export const createTuitionPost = async (postData) => {
    return apiClient.post('/tuition-posts', postData);
};

/**
 * Update a tuition post (requires auth).
 */
export const updateTuitionPost = async (postId, postData) => {
    return apiClient.put(`/tuition-posts/${postId}`, postData);
};

/**
 * Delete a tuition post (requires auth).
 */
export const deleteTuitionPost = async (postId) => {
    return apiClient.delete(`/tuition-posts/${postId}`);
};

/**
 * Update tuition post status (requires auth).
 */
export const updateTuitionPostStatus = async (postId, status) => {
    return apiClient.put(`/tuition-posts/${postId}/status?status=${status}`);
};

/**
 * Mark tuition post as fulfilled.
 */
export const markTuitionFulfilled = async (postId, remarks = '') => {
    const params = remarks ? `?remarks=${encodeURIComponent(remarks)}` : '';
    return apiClient.post(`/tuition-posts/${postId}/mark-fulfilled${params}`);
};
